export const OG_IMAGE_DIMENSIONS = {
  width: 1200,
  height: 630,
}

export const OG_IMAGE_RATIO =
  OG_IMAGE_DIMENSIONS.width / OG_IMAGE_DIMENSIONS.height

/**
 * Given a height, return the width of the image that maintains the aspect ratio
 */
export const getOGImageRatioWidth = (height: number) => {
  return OG_IMAGE_DIMENSIONS.width * (height / OG_IMAGE_DIMENSIONS.height)
}
